import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { createUpdateWorkflowViewAction } from "UI/UI.React/workflowEditor/actions";
import { createGetOrderedSets, createGetSelectedActivities, getSelectedSetId } from "UI/UI.React/workflowEditor/selectors";
import { WorkflowEditorProps } from "UI/UI.React/workflowEditor/types";
import { DuplicateActivityDialogComponent, DuplicateActivityDialogComponentProps } from "../DuplicateActivityDialogComponent";

export type DuplicateActivityDialogProps = {
    readonly duplicateTextLocKey: string;
} & WorkflowEditorProps & Pick<DuplicateActivityDialogComponentProps, "onCancelClick">;

type StateProps = Pick<DuplicateActivityDialogComponentProps, "activeSetId" | "existingsSets" | "selectedActivities" | "duplicateText">;
type DispatchProps = Pick<DuplicateActivityDialogComponentProps, "updateWorkflowView">;

const createMapStateToProps: (state: IAppState, props: DuplicateActivityDialogProps) => MapStateToProps<StateProps, DuplicateActivityDialogProps, IAppState> = () => {
    const getSelectedActivities = createGetSelectedActivities();
    const getOrderedSets = createGetOrderedSets();

    return (state, { hostKey, duplicateTextLocKey }) => ({
        activeSetId: getSelectedSetId(state, hostKey),
        existingsSets: getOrderedSets(state, hostKey),
        selectedActivities: getSelectedActivities(state, hostKey),
        setId: getSelectedSetId(state, hostKey),
        duplicateText: getPrimaryText(state, duplicateTextLocKey) ?? "",
    });
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, DuplicateActivityDialogProps> = (dispatch, { hostKey }) => ({
    updateWorkflowView: (setId, selectedActivityId, selectedTransitionId) => dispatch(createUpdateWorkflowViewAction(hostKey, setId, selectedActivityId, selectedTransitionId)),
});

export const DuplicateActivityDialog = connect(createMapStateToProps, mapDispatchToProps)(DuplicateActivityDialogComponent);
